import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cja-audit-logs"
    }}>{`CJA Audit Logs`}</h1>
    <p>{`The Audit Log API allows you to retrieve a list of audit log records using a `}<inlineCode parentName="p">{`GET`}</inlineCode>{` or `}<inlineCode parentName="p">{`POST`}</inlineCode>{` method through Adobe Developer. The `}<inlineCode parentName="p">{`GET`}</inlineCode>{` endpoint provides a way to add filters through query string parameters. The `}<inlineCode parentName="p">{`POST`}</inlineCode>{` endpoint offers greater flexibility to your search criteria.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Adobe may add optional request and response members (name/value pairs) to existing API objects at any time and without notice or changes in versioning. Adobe recommends that you refer to the API documentation of any third-party tool you integrate with our APIs so that such additions are ignored in processing if not understood. If implemented properly, such additions are non-breaking changes for your implementation. Adobe will not remove parameters or add required parameters without first providing standard notification through release notes.`}</p>
    <h2 {...{
      "id": "get-audit-logs"
    }}>{`Get Audit Logs`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`GET`}</inlineCode>{` endpoint is designed for use when few or no filters are needed. If filters are included by adding query string parameters, each query string parameter filters the list of audit logs using an 'AND' condition.`}</p>
    <p><inlineCode parentName="p">{`GET https://cja.adobe.io/auditlogs/api/v1/auditlogs`}</inlineCode></p>
    <p>{`Submitting a request to this endpoint with no query string parameters returns the last 1000 audit log records in descending order. Reference the following list of available query string parameters to filter the audit log records.`}</p>
    <h3 {...{
      "id": "query-string-parameters"
    }}>{`Query String Parameters`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Query String`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Possible Values`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`startDate`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Begin date range. If this query string is set, `}<inlineCode parentName="td">{`endDate`}</inlineCode>{` is required.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`YYYY-01-01T00:00:00-07`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`endDate`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`End date range. If this query string is set, `}<inlineCode parentName="td">{`startDate`}</inlineCode>{` is required.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`YYYY-02-01T00:00:00-07`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`action`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enum`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of action a user or system can make.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`API_REQUEST, APPROVE, CREATE, DELETE, EDIT, EXPORT, ORG_CHANGE, REFRESH, SHARE, TRANSFER, UNAPPROVE, UNSHARE`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`component`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enum`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of component.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ANNOTATION, AUDIENCE, CALCULATED_METRIC, CONNECTION, DATA_GROUP, DATA_VIEW, DATASET_STITCHING, DATE_RANGE, FEATURE_ACCESS, FILTER, IMS_ORG, MOBILE, PROJECT, REPORT, SCHEDULED_PROJECT, USER, USER_GROUP`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`componentId`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The id of the component.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`--`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`userType`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enum`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of user.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IMS, OKTA`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`userId`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The ID of the user.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`--`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`userEmail`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The email address of the user.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`User defined`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`description`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The description of the audit log.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`User defined`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`pageSize`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of results per page. If left `}<inlineCode parentName="td">{`null`}</inlineCode>{`, the default size is 100.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`pageNumber`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Page number. The first page is indexed at 0.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "example-get-audit-logs-with-no-filters"
    }}>{`Example: Get audit logs with no filters`}</h3>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X GET "https://cja.adobe.io/auditlogs/api/v1/auditlogs" \\
  -H "x-api-key: {CLIENTID}" \\
  -H "x-gw-ims-org-id: {IMSORG}" \\
  -H "Authorization: Bearer {ACCESSTOKEN}"
`}</code></pre>
    <h4 {...{
      "id": "response"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "content": [
    {
      "id": "61573795d9409a491f1a9604",
      "dateCreated": "YYYY-10-01T16:30:13.377+00:00",
      "action": "CREATE",
      "description": "Creating scheduled job: e1efbf6c-d483-408e-b033-3045e594b656",
      "imsOrgId": "EXAMPLEIMSORG@AdobeOrg",
      "user": {
        "id": "EXAMPLEUSER@AdobeID",
        "idType": "IMS",
        "name": null,
        "email": null
      },
      "component": {
        "id": "e1efbf6c-d483-408e-b033-3045e594b656",
        "idType": "SCHEDULED_PROJECT",
        "name": ""
      }
    },
    {
      "id": "615735e8d9409a491f1a9603",
      "dateCreated": "YYYY-10-01T16:23:04.821+00:00",
      "action": "DELETE",
      "description": "Deleting scheduled job: 7baaf2f8-209a-4886-9619-30f3054884ce",
      "imsOrgId": "EXAMPLEIMSORG@AdobeOrg",
      "user": {
        "id": "EXAMPLEUSER@AdobeID",
        "idType": "IMS",
        "name": null,
        "email": null
      },
      "component": {
        "id": "7baaf2f8-209a-4886-9619-30f3054884ce",
        "idType": "SCHEDULED_PROJECT",
        "name": "EOW reporting"
      }
    }
  ],
  "pageable": {
    "sort": {
      "sorted": false,
      "unsorted": true,
      "empty": true
    },
    "offset": 0,
    "pageNumber": 0,
    "pageSize": 2,
    "paged": true,
    "unpaged": false
  },
  "last": false,
  "totalElements": 1946,
  "totalPages": 973,
  "size": 2,
  "number": 0,
  "sort": {
    "sorted": false,
    "unsorted": true,
    "empty": true
  },
  "numberOfElements": 2,
  "first": true,
  "empty": false
}
`}</code></pre>
    <h3 {...{
      "id": "example-get-audit-logs-with-filters-applied"
    }}>{`Example: Get audit logs with filters applied`}</h3>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-1"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X GET "https://cja.adobe.io/auditlogs/api/v1/auditlogs?startDate=2021-08-01T00%3A00%3A00-07&endDate=2021-09-30T00%3A00%3A00-07&action=CREATE&action=EDIT&action=DELETE&component=SCHEDULED_PROJECT&userType=IMS&description=job&pageSize=2" \\
  -H "x-api-key: {CLIENTID}" \\
  -H "x-gw-ims-org-id: {IMSORG}" \\
  -H "Authorization: Bearer {ACCESSTOKEN}"
`}</code></pre>
    <h4 {...{
      "id": "response-1"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "content": [
    {
      "id": "615559925e0e8a7da2152d86",
      "dateCreated": "2021-09-30T06:30:42.968+00:00",
      "action": "CREATE",
      "description": "Creating scheduled job: ce4e1239-ab7b-471c-9d6a-14934c9d5ea4",
      "imsOrgId": "EXAMPLEIMSORG@AdobeOrg",
      "user": {
        "id": "EXAMPLEUSER@AdobeID",
        "idType": "IMS",
        "name": null,
        "email": null
      },
      "component": {
        "id": "ce4e1239-ab7b-471c-9d6a-14934c9d5ea4",
        "idType": "SCHEDULED_PROJECT",
        "name": ""
      }
    },
    {
      "id": "615556df5e0e8a7da2152d85",
      "dateCreated": "2021-09-30T06:19:11.145+00:00",
      "action": "EDIT",
      "description": "Updating scheduled job: 2dab1331-4844-4f82-94ff-9721ec47830c",
      "imsOrgId": "EXAMPLEIMSORG@AdobeOrg",
      "user": {
        "id": "EXAMPLEUSER@AdobeID",
        "idType": "IMS",
        "name": null,
        "email": null
      },
      "component": {
        "id": "2dab1331-4844-4f82-94ff-9721ec47830c",
        "idType": "SCHEDULED_PROJECT",
        "name": ""
      }
    }
  ],
  "pageable": {
    "sort": {
      "sorted": false,
      "unsorted": true,
      "empty": true
    },
    "offset": 0,
    "pageNumber": 0,
    "pageSize": 2,
    "paged": true,
    "unpaged": false
  },
  "last": false,
  "totalElements": 1246,
  "totalPages": 623,
  "size": 2,
  "number": 0,
  "sort": {
    "sorted": false,
    "unsorted": true,
    "empty": true
  },
  "numberOfElements": 2,
  "first": true,
  "empty": false
}
`}</code></pre>
    <h2 {...{
      "id": "search-audit-logs"
    }}>{`Search Audit Logs`}</h2>
    <p>{`If you need to retrieve a list of audit logs using 'OR' criteria, you can use the `}<inlineCode parentName="p">{`POST /auditlogs/search`}</inlineCode>{` endpoint. Use the following lists for available Enum values for the associated key.`}</p>
    <p><inlineCode parentName="p">{`POST https://cja.adobe.io/auditlogs/api/v1/auditlogs/search`}</inlineCode></p>
    <h3 {...{
      "id": "fieldtype"
    }}>{`fieldType`}</h3>
    <ul>
      <li parentName="ul">{`COMPONENT`}</li>
      <li parentName="ul">{`COMPONENT_ID`}</li>
      <li parentName="ul">{`USER`}</li>
      <li parentName="ul">{`USER_ID`}</li>
      <li parentName="ul">{`USER_EMAIL`}</li>
      <li parentName="ul">{`BEGIN_DATE_RANGE`}</li>
      <li parentName="ul">{`END_DATE_RANGE`}</li>
      <li parentName="ul">{`ACTION`}</li>
      <li parentName="ul">{`DESCRIPTION`}</li>
    </ul>
    <h4 {...{
      "id": "notes"
    }}>{`Notes`}</h4>
    <p><em parentName="p">{`If 'BEGIN_DATE_RANGE' is set as a fieldType, 'END_DATE_RANGE' must also be set. These fieldTypes must use 'EQUALS' as their 'operator'.`}</em></p>
    <h3 {...{
      "id": "operator"
    }}>{`operator`}</h3>
    <ul>
      <li parentName="ul">{`EQUALS`}</li>
      <li parentName="ul">{`NOT_EQUALS`}</li>
      <li parentName="ul">{`CONTAINS`}</li>
      <li parentName="ul">{`IN`}</li>
    </ul>
    <h3 {...{
      "id": "fieldoperator"
    }}>{`fieldOperator`}</h3>
    <ul>
      <li parentName="ul">{`AND`}</li>
      <li parentName="ul">{`OR`}</li>
    </ul>
    <h2 {...{
      "id": "post-request-body-example-1"
    }}>{`POST Request Body Example 1`}</h2>
    <p>{`Show me audit logs where the component is 'FILTER' or 'CALCULATED_METRIC', the 'DESCRIPTION' contains the string 'created', AND the 'USER_EMAIL' contains EITHER 'jane' or 'john'.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "criteria": {
    "fieldOperator": "AND",
    "fields": [
      {
        "fieldType": "COMPONENT",
        "value": [
          "FILTER",
          "CALCULATED_METRIC"
        ],
        "operator": "IN"
      },
      {
        "fieldType": "DESCRIPTION",
        "value": [
          "created"
        ],
        "operator": "CONTAINS"
      }
    ],
    "subCriteriaOperator": "AND",
    "subCriteria": {
      "fieldOperator": "OR",
      "fields": [
        {
          "fieldType": "USER_EMAIL",
          "value": [
            "jane"
          ],
          "operator": "CONTAINS"
        },
        {
          "fieldType": "USER_EMAIL",
          "value": [
            "john"
          ],
          "operator": "CONTAINS"
        }
      ],
      "subCriteriaOperator": null,
      "subCriteria": null
    }
  },
  "pageSize": 100,
  "pageNumber": 0
}
`}</code></pre>
    <h2 {...{
      "id": "post-request-body-example-2"
    }}>{`POST Request Body Example 2`}</h2>
    <p>{`Show me audit logs between June 1st and October 1st where the 'ACTION' was either 'CREATE' OR 'EDIT' OR the 'DESCRIPTION' contained the string 'job' or 'test'. The response only includes logs between those dates but the other criteria is filtered using 'OR' logic.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "criteria": {
    "fieldOperator": "AND",
    "fields": [
      {
        "fieldType": "BEGIN_DATE_RANGE",
        "value": [
          "YYYY-06-01T00:00:00-07"
        ],
        "operator": "EQUALS"
      },
      {
        "fieldType": "END_DATE_RANGE",
        "value": [
          "YYYY-10-01T00:00:00-07"
        ],
        "operator": "EQUALS"
      }
    ],
    "subCriteriaOperator": "AND",
    "subCriteria": {
      "fieldOperator": "OR",
      "fields": [
        {
          "fieldType": "ACTION",
          "value": [
            "CREATE",
            "EDIT"
          ],
          "operator": "IN"
        },
          {
          "fieldType": "DESCRIPTION",
          "value": [
            "job",
            "test"
          ],
          "operator": "CONTAINS"
        }
      ],
      "subCriteriaOperator": null,
      "subCriteria": null
    }
  },
  "pageSize": 10,
  "pageNumber": 0
}
`}</code></pre>
    <h2 {...{
      "id": "api-status-codes"
    }}>{`API status codes`}</h2>
    <p>{`For a description of API status codes and tips for troubleshooting, see the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/landing/troubleshooting.html#api-status-codes"
      }}>{`Platform FAQ and troubleshooting guide`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      